'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _findIndex2 = require('lodash/findIndex');

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2;

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobx = require('mobx');

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _FormDataUtils = require('../utils/FormDataUtils');

var _FormDataUtils2 = _interopRequireDefault(_FormDataUtils);

var _AppConstants = require('../constants/AppConstants');

var _AppConstants2 = _interopRequireDefault(_AppConstants);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CONTRACT_TEMPLATE_TYPE_LIEN = _AppConstants2.default.CONTRACT_TEMPLATE_TYPE_LIEN,
    LIEN_MODELS = _AppConstants2.default.LIEN_MODELS,
    LIEN_MODELS_BY_MODEL_NAME = _AppConstants2.default.LIEN_MODELS_BY_MODEL_NAME,
    MODEL_TYPES = _AppConstants2.default.MODEL_TYPES;

var LienStore = (0, _classAutobindDecorator2.default)(_class = (_class2 = function () {
  function LienStore(flatStore, caseStore, transport) {
    _classCallCheck(this, LienStore);

    this.flatStore = flatStore;
    this.caseStore = caseStore;
    this.transport = transport;
  }

  _createClass(LienStore, [{
    key: 'retrieve',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, type) {
        var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            _ref2$includeDocument = _ref2.includeDocuments,
            includeDocuments = _ref2$includeDocument === undefined ? false : _ref2$includeDocument,
            _ref2$legacy = _ref2.legacy,
            legacy = _ref2$legacy === undefined ? false : _ref2$legacy;

        var endpoint, lienData, lien;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = legacy ? '/legacy-liens/:id/' : '/' + type + '-liens/:id/';
                _context.next = 3;
                return this.transport.get(endpoint, { urlParams: { id: id } });

              case 3:
                lienData = _context.sent;
                lien = this.flatStore.lien.store(lienData);

                if (!includeDocuments) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return this.listLienDocuments(id);

              case 8:
                return _context.abrupt('return', lien);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function retrieve(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return retrieve;
    }()
  }, {
    key: 'fetchPresets',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Filtered server-side so the dropdown never offers a lending template
                params = { contract_type: CONTRACT_TEMPLATE_TYPE_LIEN };
                return _context2.abrupt('return', this.transport.get('/funder-preset-contract-templates/', { params: params }));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchPresets() {
        return _ref3.apply(this, arguments);
      }

      return fetchPresets;
    }()
  }, {
    key: 'upsertLegalFundingLien',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5) {
        var caseId = _ref5.caseId,
            lienId = _ref5.lienId,
            data = _ref5.data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Object.assign(data, {
                  case: caseId,
                  fees: data.fees || [],
                  id: lienId || _uuid2.default.v4()
                });

                _context3.next = 3;
                return this.upsert(data, LIEN_MODELS.LEGAL_FUNDING.key);

              case 3:
                return _context3.abrupt('return', _context3.sent);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function upsertLegalFundingLien(_x4) {
        return _ref4.apply(this, arguments);
      }

      return upsertLegalFundingLien;
    }()
  }, {
    key: 'upsert',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data, typeKey) {
        var endpoint, id;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                endpoint = LIEN_MODELS[typeKey].endpoint, id = data.id;

                // Supports upsert via post

                if (!(typeKey === LIEN_MODELS.LEGAL_FUNDING.key)) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 4;
                return this.transport.post('/' + endpoint + '/', { data: data });

              case 4:
                _context4.next = 14;
                break;

              case 6:
                if (id) {
                  _context4.next = 12;
                  break;
                }

                data.id = _uuid2.default.v4();
                _context4.next = 10;
                return this.transport.post('/' + endpoint + '/', { data: data });

              case 10:
                _context4.next = 14;
                break;

              case 12:
                _context4.next = 14;
                return this.transport.patch('/' + endpoint + '/:id/', { data: data, urlParams: { id: id } });

              case 14:
                _context4.next = 16;
                return Promise.all([this.list({ caseId: data.case }), this.caseStore.refresh(data.case)]);

              case 16:
                return _context4.abrupt('return', this.flatStore.lien.get(data.id));

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function upsert(_x5, _x6) {
        return _ref6.apply(this, arguments);
      }

      return upsert;
    }()
  }, {
    key: 'createOrUpdateGenericLien',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(data) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.upsert(data, LIEN_MODELS.GENERIC.key);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function createOrUpdateGenericLien(_x7) {
        return _ref7.apply(this, arguments);
      }

      return createOrUpdateGenericLien;
    }()
  }, {
    key: 'delete',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref9) {
        var caseId = _ref9.caseId,
            lienId = _ref9.lienId;

        var _flatStore$lien$get, amount_owed_to_coop, request;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _flatStore$lien$get = this.flatStore.lien.get(lienId), amount_owed_to_coop = _flatStore$lien$get.amount_owed_to_coop;

                if (!(amount_owed_to_coop !== null)) {
                  _context6.next = 4;
                  break;
                }

                _utils.toast.error('Cannot delete a lien linked to a CoOp investment. Please contact Mighty Support for further assistance.');
                return _context6.abrupt('return');

              case 4:
                request = this.transport.delete('/liens/:id/', { urlParams: { id: lienId } });
                _context6.next = 7;
                return this.caseStore.caseActivities.loadNew(MODEL_TYPES.lienDeleted.key, request);

              case 7:
                _context6.next = 9;
                return this.list({ caseId: caseId });

              case 9:
                _context6.next = 11;
                return this.caseStore.refresh(caseId);

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _delete(_x8) {
        return _ref8.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: 'rawUpdate',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(lien, data) {
        var endpoint;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                endpoint = LIEN_MODELS_BY_MODEL_NAME[lien.type].endpoint;
                return _context7.abrupt('return', this.transport.patch('/' + endpoint + '/:lienId/', { data: data, urlParams: { lienId: lien.id } }));

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function rawUpdate(_x9, _x10) {
        return _ref10.apply(this, arguments);
      }

      return rawUpdate;
    }()
  }, {
    key: 'update',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(lien, data) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.t0 = this.flatStore.lien;
                _context8.next = 3;
                return this.rawUpdate(lien, data);

              case 3:
                _context8.t1 = _context8.sent;
                return _context8.abrupt('return', _context8.t0.store.call(_context8.t0, _context8.t1));

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function update(_x11, _x12) {
        return _ref11.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: 'bulkUpdate',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(liens, data) {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt('return', Promise.all(liens.map(function (lien) {
                  return _this.rawUpdate(lien, data);
                })));

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function bulkUpdate(_x13, _x14) {
        return _ref12.apply(this, arguments);
      }

      return bulkUpdate;
    }()
  }, {
    key: 'updateLienDocument',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id, data) {
        var form;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                form = _FormDataUtils2.default.toForm(data);
                _context10.next = 3;
                return this.transport.patch('/lien-documents/:id/', { data: form, urlParams: { id: id } });

              case 3:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function updateLienDocument(_x15, _x16) {
        return _ref13.apply(this, arguments);
      }

      return updateLienDocument;
    }()
  }, {
    key: 'list',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(_ref15) {
        var _this2 = this;

        var caseId = _ref15.caseId;

        var _case, params, liens;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _case = this.flatStore.case.get(caseId), params = { case: caseId };

                if (!_case.loadingLiens) {
                  _context11.next = 3;
                  break;
                }

                return _context11.abrupt('return');

              case 3:

                _case.loadingLiens = true;
                _context11.next = 6;
                return this.transport.getAll('/liens/', { params: params });

              case 6:
                liens = _context11.sent;

                liens.forEach(function (lien) {
                  return _this2.flatStore.lien.store(lien);
                });
                _case.liens = liens.map(function (lien) {
                  return lien.id;
                });
                _case.loadingLiens = false;

              case 10:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function list(_x17) {
        return _ref14.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: 'createLienReturn',
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(_ref17) {
        var caseId = _ref17.caseId,
            data = _ref17.data;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.transport.post('/returns/', { data: data });

              case 2:
                _context12.next = 4;
                return Promise.all([this.caseStore.caseActivities.loadNew(MODEL_TYPES.lienReturnAction.key), this.caseStore.refresh(caseId), this.list({ caseId: caseId })]);

              case 4:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function createLienReturn(_x18) {
        return _ref16.apply(this, arguments);
      }

      return createLienReturn;
    }()
  }, {
    key: 'deleteLienReturn',
    value: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(returnId, lienId, caseId) {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.transport.delete('/returns/:returnId/', { urlParams: { returnId: returnId } });

              case 2:
                _context13.next = 4;
                return Promise.all([this.caseStore.caseActivities.loadNew(MODEL_TYPES.lienReturnAction.key), this.caseStore.refresh(caseId), this.list({ caseId: caseId })]);

              case 4:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function deleteLienReturn(_x19, _x20, _x21) {
        return _ref18.apply(this, arguments);
      }

      return deleteLienReturn;
    }()
  }, {
    key: 'createLienDocument',
    value: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(_ref20) {
        var lienId = _ref20.lienId,
            data = _ref20.data;
        var form, lienDocument, lien;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                form = new window.FormData();


                form.append('lien', lienId);
                form.append('file', data.file);
                form.append('name', data.name);

                _context14.next = 6;
                return this.transport.post('/lien-documents/', { data: form });

              case 6:
                lienDocument = _context14.sent;
                lien = this.flatStore.lien.get(lienId);


                lien.documents.push(lienDocument);

              case 9:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function createLienDocument(_x22) {
        return _ref19.apply(this, arguments);
      }

      return createLienDocument;
    }()
  }, {
    key: 'deleteLienDocument',
    value: function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(lienId, caseId, id) {
        var request;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                request = this.transport.delete('/lien-documents/:id/', { urlParams: { id: id } });
                _context15.next = 3;
                return this.caseStore.caseActivities.loadNew(MODEL_TYPES.deletedLienDocument.key, request);

              case 3:
                this.caseStore.fetchTabCounts(caseId);

              case 4:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function deleteLienDocument(_x23, _x24, _x25) {
        return _ref21.apply(this, arguments);
      }

      return deleteLienDocument;
    }()
  }, {
    key: 'listLienDocuments',
    value: function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(lienId) {
        var params, documents, lien;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                params = { lien: lienId, page_size: 'off' };
                _context16.next = 3;
                return this.transport.get('/lien-documents/', { params: params });

              case 3:
                documents = _context16.sent;
                lien = this.flatStore.lien.get(lienId);


                lien.extend({ documents: documents });

              case 6:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function listLienDocuments(_x26) {
        return _ref22.apply(this, arguments);
      }

      return listLienDocuments;
    }()
  }, {
    key: 'listCaseLienDocuments',
    value: function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(caseId) {
        var params;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                params = { case: caseId, page_size: 'off' };
                _context17.next = 3;
                return this.transport.get('/lien-documents/', { params: params });

              case 3:
                return _context17.abrupt('return', _context17.sent);

              case 4:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function listCaseLienDocuments(_x27) {
        return _ref23.apply(this, arguments);
      }

      return listCaseLienDocuments;
    }()
  }, {
    key: 'downloadContract',
    value: function downloadContract(lien) {
      window.location = this.transport.addAuthenticationToUrl(lien.contract_download_url);
    }
  }, {
    key: 'updateFunding',
    value: function updateFunding(funding) {
      var lien = this.flatStore.lien.get(funding.lien),
          fundingIndex = (0, _findIndex3.default)(lien.capital_fundings, { id: funding.id });

      if (fundingIndex < 0) {
        lien.capital_fundings.push(funding);
      } else {
        (0, _mobx.extendObservable)(lien.capital_fundings[fundingIndex], funding);
      }
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LienStore;
}(), (_applyDecoratedDescriptor(_class2.prototype, 'retrieve', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'retrieve'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fetchPresets', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'fetchPresets'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'upsertLegalFundingLien', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'upsertLegalFundingLien'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'upsert', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'upsert'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'createOrUpdateGenericLien', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'createOrUpdateGenericLien'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'delete', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'delete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'update', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'update'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateLienDocument', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'updateLienDocument'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'list', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'list'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'createLienReturn', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'createLienReturn'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteLienReturn', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'deleteLienReturn'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'createLienDocument', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'createLienDocument'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteLienDocument', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'deleteLienDocument'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'listLienDocuments', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'listLienDocuments'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'listCaseLienDocuments', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'listCaseLienDocuments'), _class2.prototype)), _class2)) || _class;

var _default = LienStore;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CONTRACT_TEMPLATE_TYPE_LIEN, 'CONTRACT_TEMPLATE_TYPE_LIEN', '/app/src/stores/LienStore.js');
  reactHotLoader.register(LIEN_MODELS, 'LIEN_MODELS', '/app/src/stores/LienStore.js');
  reactHotLoader.register(LIEN_MODELS_BY_MODEL_NAME, 'LIEN_MODELS_BY_MODEL_NAME', '/app/src/stores/LienStore.js');
  reactHotLoader.register(MODEL_TYPES, 'MODEL_TYPES', '/app/src/stores/LienStore.js');
  reactHotLoader.register(LienStore, 'LienStore', '/app/src/stores/LienStore.js');
  reactHotLoader.register(_default, 'default', '/app/src/stores/LienStore.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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